<template lang="html">
  <div class="activityListPage">
  	<common-header></common-header>
    <list-kv  :kvArray="kvItems"></list-kv>
    <activityList :tagArr="tagArr"></activityList>
    <common-footer></common-footer>
  </div>
</template>

<script>
	//组件
	import commonHeader from '../../components/common/commonHeader'
	import commonFooter from '../../components/common/commonFooter'
	import listKv from '../../components/common/listKv'
	import activityList from'../../components/activity/activityList.vue'
	//接口
	import Server from '../../server/server.js'
	import $ from 'jquery'
	export default {
	  	data(){
		  	return{
		  		kvItems:[],
		  		typeCode:'9902001|9902002|9902003|9902004|9902005',//资讯栏目号，分别为会员公益活动、鸿鹄投资课、君弘财富万里行、千里马培训课
		  		startIndex:0,
		  		endIndex:11,
		  		tagArr:[],
		  	}
	  	},
	  	components:{
	  		commonHeader,
	  		commonFooter,
	  		listKv,
	  		activityList,
	  	},
	  	methods:{
	  		arraySame:function (array){
			     //直接定义结果数组
			     var arr =[array[0]];
		         for(var i = 1; i <array.length; i++){    //从数组第二项开始循环遍历此数组
					if(!Array.prototype.indexOf){  
					   Array.prototype.indexOf = function(val){  
					       var value = this;  
					       for(var i =0; i < value.length; i++){  
					          if(value[i] == val) return i;  
					       }  
					      return -1;  
					   };  
					}
	                if(array.indexOf(array[i]) == i){
	                    arr.push(array[i]);
	                }
		          }
			     return arr;
			}
	  	},
	  	created(){
	  		//KV 数据
	  		Server.listConfig('activityBanner').then((result)=>{
	  			if(result.code == '0'){
	  				this.kvItems = result.msg.types;
	  			}
	  		})
	  		//获取各个资讯的标签
	  		Server.listInfo(this.startIndex,this.endIndex,this.typeCode).then((result)=>{
	  			if(result.code == '0'){
	  				let that = this;
	  				let listArr = result.msg.infos;
	  				$.each(listArr,function(index,item){
						var tagArray = (item.TAG).split("||");
						for(var j=0;j<tagArray.length;j++){
							if(tagArray[j]){
								that.tagArr.push(tagArray[j]);
							}
						}
						
					})
					that.tagArr = that.arraySame(that.tagArr);
					console.log(that.tagArr);
	  			}
	  		})
	  	},
	}
</script>

<style lang="less" scoped>
	.activityListPage{
		// padding-bottom:250px;
	}
</style>


// WEBPACK FOOTER //
// src/container/activityPage/activityList.vue